module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-cascader', _vm._g(_vm._b({
    attrs: {
      "disabled": _vm.computedDisabled,
      "clearable": _vm.computedDisabled ? false : _vm.computedClearable,
      "placeholder": _vm.computedSelectPlaceholder,
      "clear-icon-right": _vm.clearIconRight
    },
    on: {
      "change": _vm.change,
      "blur": _vm.blur,
      "focus": _vm.focus
    },
    model: {
      value: (_vm.selectedValue),
      callback: function($$v) {
        _vm.selectedValue = $$v
      },
      expression: "selectedValue"
    }
  }, 'el-cascader', _vm.$attrs, false), _vm.$listeners))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52090793"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/cascader/rtCascader.vue
// module id = 2088
// module chunks = 228